const state = {
	coercePush : false
};
const mutations = {
	changePushStatus (state,status) {
		state.coercePush = status;
	}
};
export default {
	state,
	mutations
}


// WEBPACK FOOTER //
// ./src/storage/vuex/module/infer.js